import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { IResolveAnomalyPopup } from '../../types';

const ResolveAnomalyPopup = (props: IResolveAnomalyPopup) => {
  const { toggleConfirmationPopup, onSubmit } = props;
  return (
    <div>
      <Typography className="mb-2" color="var(--navi-color-gray-c1)" variant="h3">
        Are you sure you want to Resolve ?
      </Typography>
      <div className="flex gap-2 mt-4">
        <Button fullWidth onClick={toggleConfirmationPopup} variant="secondary">
          Cancel
        </Button>
        <Button fullWidth onClick={onSubmit} variant="primary">
          Yes
        </Button>
      </div>
    </div>
  );
};

export default ResolveAnomalyPopup;
